import { motion, animate } from "motion/react";
import { useEffect, useState } from "react";
import { IoGameControllerOutline, IoCodeSlashOutline } from "react-icons/io5";
import { SlSocialYoutube } from "react-icons/sl";
import { GrCloudComputer } from "react-icons/gr";
import { PiOpenAiLogoThin } from "react-icons/pi";

export function InitialLoader() {
  const icons = [
    {
      icon: IoCodeSlashOutline,
      title: "Full Stack Developer",
      color: "#ff000d",
    },
    { icon: PiOpenAiLogoThin, title: "AI Engineer", color: "#00e5ff" },
    { icon: GrCloudComputer, title: "DevOps Engineer", color: "#b2ff00" },
    {
      icon: IoGameControllerOutline,
      title: "E-Sports Player",
      color: "#FF7722",
    },
    { icon: SlSocialYoutube, title: "YouTuber", color: "#9911ff" },
  ];

  const spring = {
    type: "spring",
    damping: 20,
    stiffness: 500,
  };

  const container = {
    listStyle: "none",
    padding: 0,
    margin: 0,
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    width: 500,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  };

  const item = {
    width: 200,
    height: 200,
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const [order, setOrder] = useState(icons);
  const [count, setCount] = useState(0);

  function shuffle([...array]) {
    return array.sort(() => Math.random() - 0.5);
  }
  useEffect(() => {
    const timeout = setTimeout(() => setOrder(shuffle(order)), 700);
    return () => clearTimeout(timeout);
  }, [order]);

  useEffect(() => {
    const controls = animate(0, 100, {
      duration: 4,
      ease: "linear",
      onUpdate(value) {
        setCount(Math.round(value));
      },
    });
    return () => controls.stop();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen bg-shade-0 text-main overflow-hidden">
      <motion.p className="text-6xl font-bold">I'm..</motion.p>
      <ul style={container}>
        {order.map(({ icon: Icon, title, color }) => (
          <motion.li key={title} layout transition={spring} style={item}>
            <div className="flex flex-col items-center justify-center">
              <Icon size={50} color={color} />
              <span className="mt-1 text-center" style={{ color }}>
                {title}
              </span>
            </div>
          </motion.li>
        ))}
      </ul>
      <motion.div className="fixed z-50 bottom-5 right-5 cursor-pointer md:text-9xl text-5xl font-bold">
        {count}%
      </motion.div>
    </div>
  );
}
